import ConstantHelper from "../../Helpers/ConstantHelper";

const ECommercePackagesData = [
  {
    id: "1",
    title: "Automated E-Commerce Package",
    overview:
      "Suitable for strong/mid/large sized enterprises and startups who are looking to work with a strong R&D, Creative and Marketing team to help select every element towards their branding, create strong digital marketing and brand presence strategies and to compete with mid/large level enterprises to grow at faster pace and start off directly at the start of the food chain.",
    offerPrice: "9999",
    actualPrice: "20000",
    featuresList: [
      { feature: "Custom Content Management System (CMS) " },
      { feature: "Unique Pages and UI Design" },
      { feature: "Complete Custom Development" },
      { feature: "Process Automation Tools" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Plugins Integration" },
      { feature: "Upto 40 Stock images" },
      { feature: "10 Unique Banner Designs" },
      { feature: "JQuery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "FREE 5 Years Hosting" },
      { feature: "Custom Email Addresses" },
      { feature: "Social Media Page Designs (Facebook, Twitter, Instagram)" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Money Back Guarantee" },
      {
        feature: "Automated Inventory/Shipping/Supplier Module:",
      },
      {
        feature:
          "Manage thousands to millions of inventory with ease and check stock levels in real-time. Receive low inventory notifications and generate purchase orders to replenish your stock.",
      },
      { feature: "Suppliers Integration (API NEEDED)" },
      { feature: "Shipper Integration (API NEEDED)" },
      { feature: "Order management" },
      { feature: "LOT numbers and expire date tracking" },
      {
        feature:
          "Transfer stock between warehouses (If Warehouse - API NEEDED)",
      },
      {
        feature:
          "Receive stock into a specific warehouse (If Warehouse - API NEEDED)",
      },
      {
        feature:
          "Fulfill orders from a particular warehouse (If Warehouse - API NEEDED)",
      },
      { feature: "Stock Management" },
      { feature: "Actionable Insights" },
      { feature: "Real- Time Visibility" },
      { feature: "Inventory Opportunities" },
      {
        feature: "Advanced Features: (API Needed For Suppliers/Warehouse)",
      },
      { feature: "Speak to suppliers during trivial conversations." },
      {
        feature:
          "Set and send actions to suppliers regarding governance and compliance materials. Place purchasing requests.",
      },
      {
        feature:
          "Research and answer internal questions regarding procurement functionalities or a supplier/supplier set.",
      },
      {
        feature:
          "Receiving/filing/documentation of invoices and payments/order requests",
      },
      { feature: "Machine Learning (ML) for Supply Chain Planning (SCP)" },
      { feature: "Machine Learning for Warehouse Management" },
      {
        feature:
          "Natural Language Processing (NLP) for Data Cleansing and Building Data Robustness",
      },
      { feature: "Automated Invoices & Estimates" },
      {
        feature:
          "Create beautiful, professional invoices & estimates in just a few seconds and then instantly email them as PDF's directly to your customers or prospects.",
      },
      { feature: "Automated Split invoicing" },
      { feature: "Automated Combine invoices" },
      { feature: "Invoice templates" },
      { feature: "Automated Barcode Scanning" },
      {
        feature:
          "Scan inventory into your orders, generate barcodes for your documents, and search for inventory or documents by scanning barcodes.",
      },
      { feature: "Locations and Zones" },
      {
        feature:
          "Have multiple warehouses, offices, or retail stores? No problem. Easily track where all your inventory is by organizing everything into locations and zones. Organize inventory items using custom attributes such as size, color, and location. View how many you have globally or at each location.",
      },
      { feature: "Customer Accounts" },
      { feature: "Performance and analytics" },
      { feature: "Customization of Personal Details" },
      { feature: "Process management" },
      { feature: "Sales Automation" },
      { feature: "Team Collaboration" },
      { feature: "Marketing Automation" },
      { feature: " Security" },
      { feature: "Integrations" },
      { feature: "Mobile Notifications" },
      { feature: "Sales Reports" },
      { feature: "Trend Analytics" },
      { feature: "Forecasting" },
      { feature: "Territory Management" },
      { feature: "Account Management" },
      { feature: "Event Integration" },
      { feature: "Advanced Data Security" },
      { feature: "Purchase Orderst" },
      {
        feature:
          "With integrated purchase orders, you can easily replenish your inventory levels by ordering more stock and even track when those new items will arrive.",
      },
      { feature: "Partial orders fulfill" },
      { feature: "Backordering" },
      { feature: "Financial Reports" },
      {
        feature:
          "Generate extremely detailed reports for your inventory, sales and services. Filter your reports by date-range and category to see what's making you the most money.",
      },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "2",
    title: "Custom E Commerce Marketplace Package",
    overview:
      "Suitable for strong marketplaces where clients can come, sell their products and customers can come and puchase where you make commision out of every sale being done through the portal with multiple revenue models. Includes a strong R&D, Creative and Marketing team to help select every element towards their branding, create strong digital marketing and brand presence strategies.",
    offerPrice: "7000",
    actualPrice: "14000",
    featuresList: [
      { feature: "Unique Pages and UI Design" },
      { feature: "Complete Custom Development" },
      { feature: "Newsfeed Integration" },
      { feature: "Social Media Plugins Integration" },
      { feature: "Advanced Ecommerce Marketplace Features" },
      { feature: "Inventory Management" },
      { feature: "CRM (Customer Relation Management System)" },
      { feature: "Advanced Admin Features 2.0" },
      { feature: "Advanced User Features" },
      { feature: "Dashboard and Analytics" },
      { feature: "Seller/Shipping Distribution" },
      { feature: "Seller Profile Management" },
      { feature: "User Profile Management" },
      { feature: "General Configuration Features" },
      { feature: "Revenue Models" },
      { feature: "Featured products" },
      { feature: "Google advertisements" },
      { feature: "Flash sales Module" },
      { feature: "Loyalty Rewards Module" },
      { feature: "Upto 40 Stock images" },
      { feature: "10 Unique Banner Designs" },
      { feature: "JQuery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "Social Media Page Designs (Facebook, Twitter, Instagram)" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Money Back Guarantee" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "3",
    title: "Custom CRM/ERP Portal Website Package",
    overview:
      "Suitable for mid/large level enterprises, who are looking to create a one-in-all Intelligent/Automated Organizational Management System within their portal to help regulate the activities of every department through one system with an AI based Back Office management system and custom user/departmental rights that can help connect processes from manufacturing, inventory management to final order fulfillment.",
    offerPrice: "15000",
    actualPrice: "30000",
    featuresList: [
      { feature: "Unique Pages and UI Design" },
      { feature: "Complete Custom Development" },
      { feature: "Newsfeed Integration" },
      { feature: "CRM (Customer Relation Management System)" },
      { feature: "Performance and analytics" },
      { feature: "Customization of Personal Details" },
      { feature: "Process management" },
      { feature: "Sales Automation" },
      { feature: "Team Collaboration" },
      { feature: "Marketing Automation" },
      { feature: "Security" },
      { feature: "Integrations" },
      { feature: "Mobile Notifications" },
      { feature: "Sales Reports" },
      { feature: "Trend Analytics" },
      { feature: "Forecasting" },
      { feature: "Territory Management" },
      { feature: "Account Management" },
      { feature: "Event Integration" },
      { feature: "Advanced Data Security" },
      { feature: "Opportunity Management" },
      { feature: "Sales Forecasting" },
      { feature: "Call/Video Logging" },
      { feature: "Quotes" },
      { feature: "Contracts" },
      { feature: "Document Library" },
      { feature: "Case Management" },
      { feature: "Analytics and Dashboards" },
      { feature: "Lead Management" },
      { feature: "Resource Management" },
      { feature: "Analytics" },
      { feature: "Web Intelligence" },
      { feature: "Automated Emails, Invoices &amp Estimates" },
      { feature: "Automated Split invoicing" },
      { feature: "Automated Combine invoices" },
      { feature: "Invoice templates" },
      { feature: "Financial Reports" },
      {
        feature:
          "Generate extremely detailed reports for your sales and services. Filter your reports by date-range and category to see what's making you the most money.",
      },
      { feature: "Generate automated sales reports" },
      { feature: "Core Modules" },
      { feature: "Human Resources" },
      { feature: "Integration" },
      { feature: "Business Intelligence" },
      { feature: "Sales/Marketing" },
      { feature: "Finance" },
      { feature: "Core Features" },
      { feature: "Reporting" },
      { feature: "Accounting" },
      { feature: "Tracking and Visibility" },
      { feature: "Centralized Modules" },
      { feature: "ERP Database" },
      { feature: "Human Resources Management" },
      { feature: "Business Process Management" },
      { feature: "Enterprise Analytics" },
      { feature: "Business Intelligence" },
      { feature: "Centralized Modules" },
      { feature: "ERP Database" },
      { feature: "Integrations" },
      { feature: "If (Manufacturing) (Optional)" },
      { feature: "Accounting" },
      { feature: "Distribution" },
      { feature: "Business Intelligence" },
      { feature: "Insights" },
      { feature: "Standardization" },
      { feature: "Procurement" },
      { feature: "Reporting and Analytics" },
      { feature: "Forecasting" },
      { feature: "Projection" },
      { feature: "Enterprise-wide integration" },
      { feature: "Real-Time Operations" },
      { feature: "Problem definition" },
      { feature: "Description of the program’s objectives and scope" },
      { feature: "Assumptions" },
      { feature: "Implementation costs" },
      { feature: "Implementation schedule" },
      { feature: "Development and operational risks" },
      { feature: "Projected benefits" },
      { feature: "Team Members" },
      { feature: "Contracts" },
      { feature: "Infrastructure Upgrades" },
      { feature: "Create work plans and timelines" },
      { feature: "Analyze gaps" },
      { feature: "Configure parameters" },
      { feature: "Migrate data" },
      { feature: "Test system" },
      { feature: "Document system" },
      { feature: "Advanced Admin Features 2.0" },
      { feature: "User Signup/Login Functionalities" },
      { feature: "Advanced User Features" },
      { feature: "User Profile Management" },
      { feature: "General Configuration Features" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Complete Deployment" },
      { feature: "Money Back Guarantee" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "4",
    title: "Beginners E-Commerce Package",
    overview:
      "Suitable for small startups who are looking to sell products online.",
    offerPrice: "999",
    actualPrice: "2000",
    featuresList: [
      { feature: "Conceptual and Dynamic Website" },
      { feature: "Content Management System (CMS)" },
      { feature: "Mobile Responsive" },
      { feature: "Easy Product Search" },
      { feature: "Product Reviews" },
      { feature: "Up To 100 Products" },
      { feature: "Up To 7 Categories" },
      { feature: "Full Shopping Cart Integration" },
      { feature: "Payment Module Integration" },
      { feature: "Sales & Inventory Management" },
      { feature: "Jquery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "FREE 1 Years Hosting" },
      { feature: "Custom Email Addresses" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Complete Deployment" },
      { feature: "Dedicated Accounts Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "5",
    title: "Corporate E-Commerce<br> Package",
    overview:
      "Suitable for strong startups looking to create a client base and develop a unique brand identity to help them stand apart from their competitors.",
    offerPrice: "1800",
    actualPrice: "3600",
    featuresList: [
      { feature: "Conceptual and Dynamic Website" },
      { feature: "Content Management System (CMS)" },
      { feature: "Mobile Responsive" },
      { feature: "Easy Product Search" },
      { feature: "Product Reviews" },
      { feature: "Unlimited Products" },
      { feature: "Unlimited Categories" },
      { feature: "Full Shopping Cart Integration" },
      { feature: "Payment Module Integration" },
      { feature: "Sales & Inventory Management" },
      { feature: "Jquery Slider" },
      { feature: "Free Google Friendly Sitemap" },
      { feature: "FREE 3 Years Hosting" },
      { feature: "Custom Email Addresses" },
      { feature: "Complete W3C Certified HTML" },
      { feature: "Facebook Page Design" },
      { feature: "Twitter Page Design" },
      { feature: "YouTube Page Design" },
      { feature: "Instagram Page Design" },
      { feature: "Complete Deployment" },
      { feature: "Dedicated Accounts Manager" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
  {
    id: "6",
    title: "Elite E-Commerce Package",
    overview:
      "Suitable for mid sized startups/enterprises who are looking to take it on the next level and grow their businesses at a much faster pace with a strong brand presence.",
    offerPrice: "3700",
    actualPrice: "7400",
    featuresList: [
      { feature: "By 6 Award Winning Designers" },
      { feature: "Icon Design" },
      { feature: "5 Rounds of Revisions" },
      { feature: "Print Media" },
      { feature: "Stationary Design (BusinessCard,Letterhead & Envelope)" },
      { feature: "Invoice Design, Email Signature" },
      { feature: "Bi-Fold Brochure (OR) 2 Sided Flyer Design" },
      { feature: "Product Catalog Design" },
      { feature: "Sign age Design (OR) Label Design" },
      { feature: "T-Shirt Design (OR) Car Wrap Design" },
      { feature: "Website" },
      { feature: "E-Commerce Store Design" },
      { feature: "Product Detail Page Design" },
      { feature: "Unique Banner Slider" },
      { feature: "Featured Products Showcase" },
      { feature: "Full Shopping Cart Integration" },
      { feature: "Unlimited Products" },
      { feature: "Unlimited Categories" },
      { feature: "Product Rating & Reviews" },
      { feature: "Easy Product Search" },
      { feature: "Payment Gateway Integration" },
      { feature: "Multi-currency Support" },
      { feature: "Content Management System" },
      { feature: "Cutomer Log-in Area" },
      { feature: "Mobile Responsive" },
      { feature: "Social Media Plugins Integration" },
      { feature: "Tell a Friend Feature" },
      { feature: "Social Media Pages" },
      {
        feature:
          "Facebook, Twitter, YouTube & Pinterest Page Designs",
      },
      { feature: "Value Added Services" },
      { feature: "Dedicated Account Manager" },
      { feature: "All Final File Formats" },
    ],
    orderNowBtn: true,
    viewDetailsBtn: true,
    CTACall: ConstantHelper.CTACall,
    CTAChat: ConstantHelper.CTAChat,
  },
];

export default ECommercePackagesData;
